import React from 'react'
import { Link } from 'react-router-dom'
import abimg from '../../images/about/ab2.png'

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const About4 = () => {
    return (
        <section className="wpo-about-section-s4 section-padding pb-120">
            <div className="container">
                <div className="wpo-about-inner">
                    <div className="row align-items-center justify-content-center">

                        {/* TEXT AREA */}
                        <div className="col-xl-5 col-lg-6 col-md-12 col-12">
                            <div className="wpo-about-text">
                                <h4>HAKKIMIZDA</h4>
                                <h2>Güven, Kalite ve Sürdürülebilir Çözümler</h2>

                                <p>
                                    KYS Lojistik Proje İnşaat Madencilik Makina San. ve Tic. Ltd. Şti.,
                                    2016 yılından bu yana; soğutma sistemleri, iç mimarlık & proje uygulama
                                    ve iş makineleri alanlarında faaliyet gösteren çok disiplinli bir
                                    mühendislik ve uygulama firmasıdır.
                                </p>

                                <p>
                                    Kuruluşumuzdan itibaren kalite standartlarını esas alan, güven odaklı
                                    ve sürdürülebilir hizmet anlayışını benimseyerek sektörümüzde istikrarlı
                                    bir büyüme sağladık. Her projede teknik yeterlilik, zamanında teslim
                                    ve müşteri memnuniyetini öncelik olarak görmekteyiz.
                                </p>

                                <p>
                                    Gelişen teknolojileri yakından takip ederek enerji verimliliği yüksek,
                                    ekonomik, uzun ömürlü ve çevreye duyarlı çözümler üretmekteyiz.
                                    Güçlü teknik altyapımız ve deneyimli uzman kadromuzla projelerimizi
                                    eksiksiz ve profesyonel şekilde hayata geçiriyoruz.
                                </p>

                                <Link onClick={ClickHandler} className="theme-btn" to="/service">
                                    Hizmetlerimizi İnceleyin
                                </Link>
                            </div>
                        </div>

                        {/* IMAGE AREA */}
                        <div className="col-xl-7 col-lg-6 col-md-12 col-12">
                            <div className="wpo-about-wrap">
                                <div className="wpo-about-img">
                                    <div className="inner-img">
                                        <img src={abimg} alt="KYS Lojistik Hakkımızda" />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div className="shape-ab"></div>
        </section>
    )
}

export default About4;